<template>
  <q-separator :spaced="spaced ? true : undefined" />
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'CSeparator',
  props: {
    spaced: {
      type: Boolean,
    },
  },
});
</script>
